import { render, staticRenderFns } from "./DatafieldOptionItem.vue?vue&type=template&id=0fe138d9"
import script from "./DatafieldOptionItem.vue?vue&type=script&lang=js"
export * from "./DatafieldOptionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports